import { useMutation } from '@tanstack/react-query';

import type {
  NewClientActionResponse,
  NewClientFormResponse,
} from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useNewClientFormMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      method: 'POST' | 'PUT';
      data: FormData;
    }) =>
      HttpClient.request<NewClientFormResponse>({
        method: params.method,
        url: params.url,
        data: params.data,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }),
  });

export const useConfirmNewClientMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<NewClientActionResponse>({
        method: 'POST',
        url,
      }),
  });

export const useRejectNewClientMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<NewClientActionResponse>({
        method: 'POST',
        url,
      }),
  });
